import { dialogDefault, DIALOG_GOALUSERS } from "../consts";

const mydialog = {...dialogDefault}


export const goalUsersDialogAction = ({ open = false, id = 0, goalId=0, text=''  }) => ({
    type: DIALOG_GOALUSERS,
    payload : { open, id, goalId, text  }
});

export default function goalUsersDialogReducer(state = mydialog, { type, payload }) {

    const actions = {
        [DIALOG_GOALUSERS] : () => ({...state, ...payload })
    }

    return actions[type]?.call() || state;
}

